import { Model } from './model';

export class Credits extends Model {
  money: number | null;
  types: Type[] | null;
  nations: CreditNationType[];
  subscriptions: Subscription[];

  afterDeserialize(input: any) {
    if (input.money === undefined) {
      this.money = null;
    }
    if (input.subscriptions === undefined) {
      this.subscriptions = [];
    }
  }
}

export class Subscription extends Model {
  type: string;
  details: Details;
}

export class Details extends Model {
  status: boolean;
  subscriptionName: string;
  subscriptionLabel: string;
  subscriptionPurchaseTime: string;
  subscriptionExpiryTime: string;
  bundled: boolean;
  maxDomains: number;
  usedDomains: number;
  recurringSubscription: boolean;
  maxPages: string;
  idSim: string;
  usedPages: number;
  canActivateTrial: boolean;
  isTrial: boolean;
  note?: string;
}

export interface Subscription extends Model {
  type: string;
  details: Details;
}

export class Type extends Model {
  constructor(public type: string, public quantity: number) {
    super();
  }
}

export class CreditNationType extends Type {
  nation: string;
}
